/* ==========================================================================
   Privacy Page (V5) — test build
   Scripts for templates/page.privacy-test.liquid
   Drives the "Funcionalidades Pro" horizontal scroll-snap carousel: builds
   pagination dots from the card count, scrolls to a card on dot click, and
   keeps the active dot in sync with scroll position.
   ========================================================================== */
(function () {
  function initCarousel(root) {
    var track = root.querySelector('[data-pv-carousel-track]');
    var dotsWrap = root.querySelector('[data-pv-carousel-dots]');
    if (!track || !dotsWrap) return;

    var cards = Array.prototype.slice.call(track.querySelectorAll('[data-pv-carousel-card]'));
    if (!cards.length) return;

    cards.forEach(function (card, index) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'pv-ai__dot';
      dot.setAttribute('aria-label', 'Ir a la tarjeta ' + (index + 1));
      dot.addEventListener('click', function () {
        track.scrollTo({ left: card.offsetLeft - track.offsetLeft, behavior: 'smooth' });
      });
      dotsWrap.appendChild(dot);
    });

    var dots = Array.prototype.slice.call(dotsWrap.querySelectorAll('.pv-ai__dot'));

    function setActiveDot() {
      var scrollLeft = track.scrollLeft;
      var closestIndex = 0;
      var closestDistance = Infinity;

      cards.forEach(function (card, index) {
        var distance = Math.abs((card.offsetLeft - track.offsetLeft) - scrollLeft);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });

      dots.forEach(function (dot, index) {
        dot.classList.toggle('is-active', index === closestIndex);
      });
    }

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        setActiveDot();
        ticking = false;
      });
    });

    window.addEventListener('resize', setActiveDot);
    setActiveDot();

    // Mouse drag-to-scroll: touch devices already scroll natively via
    // overflow-x:auto, this adds click-and-drag for desktop mouse users.
    var isDown = false;
    var didDrag = false;
    var startX = 0;
    var startScrollLeft = 0;

    track.addEventListener('mousedown', function (e) {
      isDown = true;
      didDrag = false;
      track.classList.add('is-dragging');
      startX = e.pageX - track.offsetLeft;
      startScrollLeft = track.scrollLeft;
    });

    function endDrag() {
      isDown = false;
      track.classList.remove('is-dragging');
    }
    track.addEventListener('mouseleave', endDrag);
    track.addEventListener('mouseup', endDrag);

    track.addEventListener('mousemove', function (e) {
      if (!isDown) return;
      e.preventDefault();
      var x = e.pageX - track.offsetLeft;
      var walk = x - startX;
      if (Math.abs(walk) > 5) didDrag = true;
      track.scrollLeft = startScrollLeft - walk;
    });

    // Swallow the click that follows a drag so releasing over a card link
    // (e.g. "Más información.") doesn't navigate away unintentionally.
    track.addEventListener('click', function (e) {
      if (didDrag) {
        e.preventDefault();
        e.stopPropagation();
      }
    }, true);
  }

  document.addEventListener('DOMContentLoaded', function () {
    var carousels = document.querySelectorAll('[data-pv-carousel]');
    carousels.forEach(initCarousel);
  });
})();
